module.exports = __webpack_public_path__ + "static/media/Privacy-5.99c29de5.png";